import { BehaviorSubject } from "rxjs";
import _ from "lodash";
import {InvalidLanguageException, InvalidRegionException} from "../../errors";

const currencies = {
    "GBL": "",
    "US": "USD",
    "CA": "CAD",
    "QC": "CAD",
    "FR": "EUR",
    "DE": "EUR",
    "AU": "AUD",
    "JP": "JPY",
    "NZ": "NZD"
};

const currencySymbols = {
    "GBL": "",
    "US": "$",
    "CA": "$",
    "QC": "$",
    "FR": "€",
    "DE": "€",
    "AU": "$",
    "JP": "¥",
    "NZ": "$"
};

export class ProfileManager {

    constructor(localization, Intl) {
        this._allowedLanguages = [];
        this._allowedRegions = ["CA", "QC", "US", "FR", "DE", "AU", "JP", "NZ", "GBL"];
        this._lang = null;
        this._lang$ = new BehaviorSubject(null);
        this._region = null;
        this._queryString = null;
        this._localization = localization;
        this._Intl = Intl;
        this._playerID = null;
        this._displayPrice = false;
    }

    get playerID() {
        return this._playerID;
    }

    get interestRate() {
        let interestRate;

        switch (this._region){
            case "CA" :
                interestRate = 4.99;
                break;
            case "QC" :
                interestRate = 4.99;
                break;
            case "US" :
                interestRate = 6.99;
                break;
            default:
                interestRate = 4.99;
                break;
        }

        return interestRate
    }

    get localizedInterestRate() {
        const locale = this.lang;
        let rate = this.interestRate;
        let localized = (new this._Intl.NumberFormat(locale, {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2
        })).format(rate);
        return localized;
    }

    get terms() {
        let terms;

        switch (this._region){
            case "CA" :
                terms = 60;
                break;
            case "QC" :
                terms = 60;
                break;
            case "US" :
                terms = 60;
                break;
            default:
                terms = 60;
                break;
        }

        return terms
    }

    set playerID(playerID) {
        this._playerID = playerID;
    }

    get lang() {
        return this._lang;
    }

    get lang$() {
        return this._lang$;
    }

    get region() {
        return this._region;
    }

    get allowedLanguages() {
        return this._allowedLanguages;
    }

    get queryString() {
        return this._queryString;
    }

    get currency() {
        return currencies[this.region];
    }

    get allowedRegions(){
        return this._allowedRegions
    }

    set lang(lang) {
        if (this._allowedLanguages.includes(lang)) {
            this._lang = lang;
            this._lang$.next(lang);
            this._localization.locale = lang;
        } else {
            throw new InvalidLanguageException(`[ProfileManager] ${lang} is not a valid language`)
        }
    }

    set region(region) {
        if (this._allowedRegions.includes(region)) {
            this._region = region;
        } else {
            throw new InvalidRegionException(`[ProfileManager] ${region} is not a valid region`);
        }
    }

    get isNA(){
        switch (this.region) {
            case "CA":
                return true;
                break;
            case "QC":
                return true;
                break;
            case "US":
                return true;
                break;
            default:
                return false;
        }
    }

    initialize(allowedLanguages, region, playerID, queryString, hidePrice) {
        this._queryString = queryString;
        this._allowedLanguages = allowedLanguages;

        this.lang = this._allowedLanguages[0];
        this.region = region;
        this.playerID = playerID;
        this._displayPrice = hidePrice;
    }

    toggleLanguage() {
        console.log("[ProfileManager] toggle language", this._lang);

        if (this._lang === "fr") {
            this.lang = "en";
        } else {
            this.lang = "fr";
        }
    }

    localizePrice(value, hideDecimal = false) {
        if (value === NaN) {
            debugger;
        }
        const locale = this.lang;
        const currency = currencies[this.region];

        // Used to escape console warnings in the event region is global and no currency is needed
        if(this.region == "GBL"){
            return;
        }
        else if (_.isEmpty(currency)) {
            console.warn("Asked for a localized price when the region has no currency code!");
            return "";
        }

        let decimalDigitals = hideDecimal ? 0 : 2;
        const localizedParts = (new this._Intl.NumberFormat(locale, {
            maximumFractionDigits: decimalDigitals,
            minimumFractionDigits: decimalDigitals,
            currencyDisplay: "symbol",
            style: "currency",
            currency
        })).formatToParts(value);
        const localized = localizedParts.map((part) => {
            if (part.type === 'currency') {
                return currencySymbols[this.region];
            }
            return part.value;
        });
        console.log(`localized: ${localized.join('')}`, localized.join(''));
        return localized.join('');
    }

    hidePrice(){
        if(this._region === 'GBL'){
            return true
        }
        else if(this._displayPrice !== true){
            return true
        }else{
            return false
        }
    }
}


// WEBPACK FOOTER //
// ./src/managers/Profile/index.js